<template>
  <InputText type="text" v-model="data" class="user-input" :style="{ 'width': width }" v-show="!show"
    @input="$emit('input', data)" />
  <label v-show="show">{{ data }}</label>
</template>

<script>

export default {
  name: 'InputLabel',
  props: {
    data: String,
    show: Boolean,
    width: String
  }
}
</script>
<style scoped>
.user-input {
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  font-family: 'Times New Roman', Times, serif;
  border: 1px solid #22b625;
}
</style>